module.exports = __webpack_public_path__ + "img/rotateLogo_EN.582be106.png";